export abstract class FleekError<T> extends Error {
  public abstract name: string;
  public data: T;

  // eslint-disable-next-line fleek-custom/valid-argument-types
  constructor(data: T) {
    super();

    this.data = data;
  }

  get message() {
    return this.toString();
  }

  abstract toString(): string;
}
